import { closeModal } from "../../../../../store/redux/slice/ComponentsControl/groupsControl";
import { ViewDialog } from "@duosoftbg/nacid-components";
import useAppDispatch from "../../../../../hooks/redux/base/useAppDispatch";
import useAppSelector from "../../../../../hooks/redux/base/useAppSelector";
import GroupMainDetailsForm from "./parts/GroupMainDetailsForm";
import { groupInitialValues } from "../../../../../init/groupsAndRolesInitialValues";

const GroupCreateDialog = ({ filterFn }) => {
  const dispatch = useAppDispatch();

  const { open } = useAppSelector((state) => {
    return state.ComponentsControl.groupsControl.modals.create;
  });

  return (
    <div>
      <ViewDialog
        open={open}
        onClose={() => dispatch(closeModal({ modalType: "create" }))}
        title={"t.group.create.dialog"}
      >
        <GroupMainDetailsForm group={groupInitialValues} filterFn={filterFn} />
      </ViewDialog>
    </div>
  );
};

export default GroupCreateDialog;
